import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FileText, BookOpen, Camera, Cpu } from 'lucide-react';
import './style/AddExam.css'

export default function AddExam() {
  const navigate = useNavigate();

  const handleUploadExam = () => {
    navigate('/exams/upload-exam');
  };
  const handleClickPhoto = () => {
    alert('Opening camera for clicking photos');
  };
  const handleCreateFromSyllabus = () => {
    navigate('/exams/create-from-syllabus');
  };

  const handleCreateWithAI = () => {
    navigate('/exams/create-with-ai');
  };

  return (
    <div className="unique15-add-exam-container  bg-gradient-to-br from-blue-100 to-purple-100 min-h-screen">
      <h1 className="unique15-title">Create an Exam</h1>
      <p className="unique15-subtitle">Choose a method to create your exam</p>
      
      <div className="unique15-exam-options">
        <div className="unique15-exam-card">
          <div className="unique15-icon-container">
            <FileText size={48} />
          </div>
          <h2>Upload Exam</h2>
          <p>Upload an existing exam file in PDF or document format.</p>
          <button className="unique15-select-btn" onClick={handleUploadExam}>Select</button>
        </div>

        <div className="unique15-exam-card">
          <div className="unique15-icon-container">
            <BookOpen size={48} />
          </div>
          <h2>Create from Syllabus</h2>
          <p>Generate an exam based on your course syllabus and learning objectives.</p>
          <button className="unique15-select-btn" onClick={handleCreateFromSyllabus}>Select</button>
        </div>

        <div className="unique15-exam-card">
          <div className="unique15-icon-container">
            <Camera size={48} />
          </div>
          <h2>Upload Photos</h2>
          <p>Take a photo of a physical Exam sheet to create a digital version.</p>
          <button className="unique15-select-btn" onClick={handleClickPhoto}>Select</button>
        </div>

        <div className="unique15-exam-card">
          <div className="unique15-icon-container">
            <Cpu size={48} />
          </div>
          <h2>Create with AI</h2>
          <p>Use AI to generate a customized exam based on your specifications.</p>
          <button className="unique15-select-btn" onClick={handleCreateWithAI}>Select</button>
        </div>
      </div>
    </div>
  );
}